import type { APIHomeSection } from '~/api/commonApi'
import type { THomeSection, THomeSectionAnimation } from '~/layers/homepage/data/types'
import { THomeSectionType } from '~/layers/homepage/data/types'
import { log } from '~/layers/homepage/data/logger'

export const make = (apiSection: APIHomeSection, index: number): (THomeSectionAnimation & THomeSection)[] | null => {
  const title = apiSection.title

  const sections: (THomeSectionAnimation & THomeSection)[] = []

  for (const apiSectionChild of apiSection.children) {
    if (Array.isArray(apiSectionChild.images)) {
      log(`Изображение дочернего элемента анимации ID ${apiSectionChild.id} не установлено. Пропуск`, apiSectionChild)
      continue
    }

    sections.push({
      type: THomeSectionType.Animation,
      picture: apiSectionChild.images,
      title: title,
      navigation: {
        title: apiSectionChild.title,
        icon: apiSectionChild.icon,
        description: apiSectionChild.subtitle,
        buttonText: apiSectionChild.buttonText,
        buttonLink: apiSectionChild.link,
      },
      isSquad: Array.isArray(apiSectionChild.configuration)
        ? false
        : apiSectionChild.configuration.isSquad
    })
  }

  return sections
}
